import { Article } from '../types';

export const articlesData: Article[] = [
  // ============ CUSTOMER MANAGEMENT ============
  // Note: Customer articles are in detailedArticles.ts with comprehensive content

  // ============ APPOINTMENTS ============
  // Note: Appointment Scheduling article is in detailedArticles.ts with comprehensive content

  // ============ FINANCIAL MANAGEMENT ============
  // Note: Invoicing & Billing article is in detailedArticles.ts with comprehensive content

  // ============ TODO LISTS ============
  {
    id: 'todo-1',
    title: 'Managing Todo Lists',
    slug: 'managing-todo-lists',
    description: 'Track tasks and stay organized with todo lists',
    category: 'tools',
    tags: ['todos', 'tasks', 'productivity'],
    lastUpdated: new Date('2024-02-01'),
    readTime: 5,
    content: `<h2>Todo List Management</h2><p>Stay organized with tasks...</p>`,
    relatedArticles: ['daily-notes']
  },
  {
    id: 'todo-2',
    title: 'Daily Notes',
    slug: 'daily-notes',
    description: 'Keep track of daily activities and notes',
    category: 'tools',
    tags: ['notes', 'daily', 'tracking'],
    lastUpdated: new Date('2024-02-02'),
    readTime: 4,
    content: `<h2>Daily Notes Feature</h2><p>Document daily activities...</p>`,
    relatedArticles: ['managing-todo-lists']
  },

  // ============ ORDERS & INVENTORY ============
  {
    id: 'ord-1',
    title: 'Creating Orders',
    slug: 'creating-orders',
    description: 'How to create and manage customer orders',
    category: 'orders',
    tags: ['orders', 'sales', 'processing'],
    lastUpdated: new Date('2024-02-05'),
    readTime: 6,
    content: `<h2>Creating Orders - Coming Soon</h2><p>This feature documentation is coming soon. Please check back later for detailed information on creating and managing orders.</p>`,
    relatedArticles: ['inventory-management']
  },
  // Note: Inventory Management article has comprehensive content in inventoryManagementArticle.ts

  // ============ SERVICE MANAGEMENT ============
  {
    id: 'serv-1',
    title: 'Service Items Setup',
    slug: 'service-items-setup',
    description: 'Configure your service offerings and pricing',
    category: 'services',
    tags: ['services', 'pricing', 'configuration'],
    lastUpdated: new Date('2024-02-10'),
    readTime: 7,
    content: `<h2>Setting Up Service Items</h2><p>Configure service catalog...</p>`,
    relatedArticles: ['window-cleaning-estimator', 'pressure-washing-estimator']
  },
  {
    id: 'serv-2',
    title: 'Window Cleaning Estimator',
    slug: 'window-cleaning-estimator',
    description: 'Use the automated window cleaning estimate tool',
    category: 'services',
    tags: ['window cleaning', 'estimates', 'calculator'],
    lastUpdated: new Date('2024-02-11'),
    readTime: 6,
    content: `<h2>Window Cleaning Calculator</h2><p>Automated pricing tool...</p>`,
    relatedArticles: ['service-items-setup', 'generating-estimates']
  },
  {
    id: 'serv-3',
    title: 'Pressure Washing Estimator',
    slug: 'pressure-washing-estimator',
    description: 'Calculate pressure washing service estimates',
    category: 'services',
    tags: ['pressure washing', 'estimates', 'calculator'],
    lastUpdated: new Date('2024-02-12'),
    readTime: 6,
    content: `<h2>Pressure Washing Calculator</h2><p>Estimate pressure washing jobs...</p>`,
    relatedArticles: ['service-items-setup', 'generating-estimates']
  },

  // ============ MARKETING ============
  {
    id: 'mkt-1',
    title: 'Lead Management',
    slug: 'lead-management',
    description: 'Track and convert leads into customers',
    category: 'marketing',
    tags: ['leads', 'conversion', 'sales'],
    lastUpdated: new Date('2024-02-15'),
    readTime: 8,
    content: `<h2>Managing Leads</h2><p>Lead tracking and conversion...</p>`,
    relatedArticles: ['marketing-campaigns', 'customer-lists']
  },
  {
    id: 'mkt-2',
    title: 'Creating Marketing Lists',
    slug: 'customer-lists',
    description: 'Segment customers for targeted marketing',
    category: 'marketing',
    tags: ['lists', 'segmentation', 'targeting'],
    lastUpdated: new Date('2024-02-16'),
    readTime: 6,
    content: `<h2>Customer Segmentation</h2><p>Create targeted lists...</p>`,
    relatedArticles: ['marketing-campaigns', 'lead-management']
  },
  {
    id: 'mkt-3',
    title: 'Email & SMS Campaigns',
    slug: 'marketing-campaigns',
    description: 'Launch marketing campaigns to your customers',
    category: 'marketing',
    tags: ['campaigns', 'email', 'sms', 'marketing'],
    lastUpdated: new Date('2024-02-17'),
    readTime: 10,
    content: `<h2>Campaign Management</h2><p>Create and launch campaigns...</p>`,
    relatedArticles: ['customer-lists', 'campaign-templates']
  },
  {
    id: 'mkt-4',
    title: 'Campaign Templates',
    slug: 'campaign-templates',
    description: 'Use and create reusable message templates',
    category: 'marketing',
    tags: ['templates', 'campaigns', 'reusable'],
    lastUpdated: new Date('2024-02-18'),
    readTime: 5,
    content: `<h2>Message Templates</h2><p>Create reusable templates...</p>`,
    relatedArticles: ['marketing-campaigns']
  },

  // ============ DOCUMENTS ============
  {
    id: 'doc-1',
    title: 'Document Management',
    slug: 'document-management',
    description: 'Store and organize business documents',
    category: 'documents',
    tags: ['documents', 'files', 'storage'],
    lastUpdated: new Date('2024-02-20'),
    readTime: 6,
    content: `<h2>Managing Documents</h2><p>Organize your files...</p>`,
    relatedArticles: ['pdf-generation', 'document-templates']
  },
  {
    id: 'doc-2',
    title: 'PDF Generation',
    slug: 'pdf-generation',
    description: 'Generate PDF documents for invoices and reports',
    category: 'documents',
    tags: ['pdf', 'generation', 'export'],
    lastUpdated: new Date('2024-02-21'),
    readTime: 5,
    content: `<h2>PDF Export</h2><p>Generate PDF documents...</p>`,
    relatedArticles: ['document-management', 'creating-invoices']
  },

  // ============ ADMIN & SETTINGS ============
  {
    id: 'adm-1',
    title: 'Employee Management',
    slug: 'employee-management',
    description: 'Manage employee accounts and access',
    category: 'admin',
    tags: ['employees', 'users', 'management'],
    lastUpdated: new Date('2024-02-25'),
    readTime: 8,
    content: `<h2>Managing Employees</h2><p>Employee account setup...</p>`,
    relatedArticles: ['user-roles', 'employee-hours']
  },
  {
    id: 'adm-2',
    title: 'User Roles & Permissions',
    slug: 'user-roles',
    description: 'Configure access levels and permissions',
    category: 'admin',
    tags: ['roles', 'permissions', 'access', 'security'],
    lastUpdated: new Date('2024-02-26'),
    readTime: 7,
    content: `<h2>Role-Based Access</h2><p>Setting up permissions...</p>`,
    relatedArticles: ['employee-management']
  },
  {
    id: 'adm-3',
    title: 'Employee Time Tracking',
    slug: 'employee-hours',
    description: 'Track employee work hours and timesheets',
    category: 'admin',
    tags: ['time tracking', 'hours', 'timesheets'],
    lastUpdated: new Date('2024-02-27'),
    readTime: 6,
    content: `<h2>Time Tracking</h2><p>Monitor employee hours...</p>`,
    relatedArticles: ['employee-management', 'analytics']
  },
  {
    id: 'adm-4',
    title: 'Business Analytics',
    slug: 'analytics',
    description: 'View reports and business insights',
    category: 'admin',
    tags: ['analytics', 'reports', 'insights', 'metrics'],
    lastUpdated: new Date('2024-02-28'),
    readTime: 9,
    content: `<h2>Analytics Dashboard</h2><p>Business performance metrics...</p>`,
    relatedArticles: ['employee-hours']
  },

  // ============ GETTING STARTED ============
  // Note: First Login & Setup and Company Profile articles are imported from separate files
  // with comprehensive content (firstLoginArticle.ts and companyProfileArticle.ts)
];